/**
 * Converts the form state (strings from the inputs) into the API contract for creating or
 * updating a hardware catalogue item. Empty price and VAT become null ("price on request").
 */
const toNumberOrNull = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export function toHardwareProductPayload(product) {
  return {
    name: (product?.name || "").trim(),
    category: product?.category || null,
    articleNumber: product?.articleNumber || null,
    description: product?.description || null,
    specification: product?.specification || null,
    price: toNumberOrNull(product?.price),
    currency: (product?.currency || "SEK").trim().toUpperCase(),
    vat: toNumberOrNull(product?.vat),
    imageUrl: product?.imageUrl || null,
    isPublished: !!product?.isPublished,
    sortOrder: toNumberOrNull(product?.sortOrder) ?? 0,
  };
}

export const MAX_IMAGE_BYTES = 2 * 1024 * 1024;
const ACCEPTED_IMAGE_TYPES = ["image/png", "image/jpeg", "image/webp"];

/**
 * Client-side check of an image file before upload; the API checks the bytes again. Returns an
 * error message, or null when the file may be sent.
 */
export function validateImageFile(file) {
  if (!file) return "Choose an image file.";
  if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) return "Only PNG, JPEG and WebP images are accepted.";
  if (file.size > MAX_IMAGE_BYTES) return "The image may be at most 2 MB.";
  return null;
}

export const EMPTY_HARDWARE_PRODUCT = {
  name: "",
  category: "",
  articleNumber: "",
  description: "",
  specification: "",
  price: "",
  currency: "SEK",
  vat: "",
  imageUrl: "",
  isPublished: false,
  sortOrder: 0,
};
